const MAX_PLACEHOLDER = /\{\{\s*max\s*\}\}/g

/**
 * Resolves the "you may buy at most N" alert for a quantity that was lowered to
 * the customer's ceiling.
 *
 * The ceiling is per customer and per product, so the number cannot live in the
 * translated string — the template carries a `{{max}}` placeholder and this
 * fills it in. A template without the placeholder is still returned as written:
 * a storefront is free to word the message without naming the number.
 *
 * An absent or empty template is not a switch, it is simply nothing to say. The
 * caller falls back to the alert it would have shown before this message existed,
 * so a storefront that never configures one behaves exactly as it always did.
 *
 * @param template The configured `texts.cart.maxQuantityMessage`, if any.
 * @param max The cap that was applied.
 * @returns The message to show, or `undefined` when there is none to show.
 */
export const formatMaxQuantityMessage = (
  template: string | undefined,
  max: number | undefined,
): string | undefined => {
  if (typeof template !== 'string' || template.trim() === '') {
    return undefined
  }
  if (typeof max !== 'number' || !Number.isFinite(max)) {
    return undefined
  }
  return template.replace(MAX_PLACEHOLDER, String(max))
}

export default formatMaxQuantityMessage
